export const PATTERNS = Object.freeze({
    video: '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%.\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%\\+.~#?&//=]*)',
    video2: '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%.\\+#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%\\+.#?&//=]*)',
    video3: '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%.\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%\\+.~#?&//=_]*)',
    video4: '((http|https)://)(www.)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)',
    video5: '((http|https)://)(www.)?(vimeo|youtube).com/?[-a-zA-Z0-9@:%.\\+~#=]{2,256}?.*$',
    timestamp: '[0-9][0-9]:[0-5][0-9]:[0-5][0-9]',
    displayOrder: '[1-9][0-9]*',
    maxTen: '^[1-9]|10$',
    positiveNumbers: '^(?!-)[0-9]+(.[0-9]+)?$',
    duration: '^[0-9]+[0-9]*$',
    totalMarks: '^[1-9][0-9]*',
    anyNumberRange: '^\\d+(.\\d+)?-\\d+(.\\d+)?$',
    zeroToHundredWithDecimal: '^(100(\\.00?)?|[0-9]{1,2}(\\.[0-9]{1,6})?)$',
    charLimit: (min, max) => `^.{${min},${max}}$`,
    minCharLimit: (min) => `^.{${min},}$`,
    rating: '[1-5]',
    phone: '^[6-9]{1}[0-9]{9}$',
    phoneGccCountry: '^[1-9][0-9]{4,11}$',
    tenDigitNumber: '^[1-9][0-9]{9}$',
    email: '^[\\w._-]+[+]?[\\w._-]+@[\\w.-]+\\.[a-zA-Z]{2,6}$',
    email2: '^[A-Za-z0-9](([_\\.\\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\\.\\-]?[a-zA-Z0-9]+)*)\\.([A-Za-z]{2,})$',
    email3: '^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$',
    emailPw: '^[a-zA-Z0-9_.]+@pw.live',
    password: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$',
    textWithoutLeadingTrailingSpaces: '^$|^\\S{1}$|^\\S+.*\\S+$',
    noWhiteSpace: '^\\S+$',
    nonNegNonDecNumber: '^(?:0|[1-9]\\d*)$',
    minZeroWithoutDecimal: '^(?!0d)([0-9]+)$',
    issueComment: '^(\\n|\\t|\\r|.){40,255}$',
    minZeroWithDecimal: '^(+?d+|-?0+)$',
    nonNegDecimalUptoTwoDigit: '^(?!-|0*\\.0*$)\\d*(\\.\\d{1,2})?$',
    nonZeroNonDecimal: '^[1-9]\\d*$',
    timePatternHH_mm: '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
    noSpecialChars: '^[a-zA-Z0-9\\s]*$',
    ratingOneToFive: '^(?:[1-4](?:\\.\\d{1,2})?|5(?:\\.0{1,2})?)$',
    removeExtention: '\\.[^.]+$',
    nonZeroDecimalUptoTwoDigit:
        '^(?!0(\\.0{1,2})?$)([1-9]\\d*(\\.\\d{1,2})?|0\\.\\d{1,2})$',
    mongoDbIdValidation: '^[a-fA-F0-9]{24}$',
    mongoDBIdPattern: '^[a-fA-F0-9]{24}$',
    obsIpPort: '^ws://\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}:\\d{4}$',
    removeHtmlTag: /<[^>]*>/g,
    colorHexCode: '^#([A-Fa-f0-9]{6})$',
    numberFromZero: '^[0-9]+$',
    percentagePattern:
        '^(?:0\\.(?:[1-9]\\d?|\\d[1-9])|[1-9]\\d?(?:\\.\\d{1,2})?)$',
    daysInMonth: '^([1-9]|[12][0-9]|3[01])$',
    configName: '^[^0-9]{1,14}$',
    nonDigitCharacter: '/\\D/g',
    year: '^[0-9]{4}$',
    positiveNumberWithZero: '^(0|[1-9]\\d*)$',
    validLink: '^(https?:\\/\\/)?([\\w-]+\\.)+[\\w-]{2,}(\\/\\S*)?$',
    numberZeroTo24: '^(0|[1-9]|1[0-9]|2[0-4])$',
    numberZeroTo100: '^(0|[1-9]|[1-9][0-9]|100)$',
    slugReplaceNonAlphanumeric: '[^a-z0-9]+',
    slugTrimDashes: '^-+|-+$',
    normalize_line_endings: '/\r\n/g',
    BASE64_SANITIZE_PATTERN: '/[^A-Za-z0-9+/=]/g',
    removeFileExtension: '\\.[^/.]+$',
});
